// Ported from native/src/editor/activity/plugins/challenge/TreasureMapFlow.js:213-221.
// Phase-machine activity: success = terminal state in runTrace OR phaseFlags.completed.

'use strict';

const {reachedTerminalState, totalBlockCount} = require('./helpers');

function evaluate (activityData, simState) {
    const phaseFlags = (simState && simState.phaseFlags) || {};
    const interactionTypes = Array.isArray(phaseFlags.interactionTypes)
        ? phaseFlags.interactionTypes.slice()
        : [];
    return {
        success: reachedTerminalState(simState),
        usedBlocks: totalBlockCount(simState),
        storyPhase: phaseFlags.storyPhase || null,
        flagTapCount: phaseFlags.flagTapCount || 0,
        interactionTypes
    };
}

module.exports = evaluate;
